export default __webpack_public_path__ + "static/media/bg-xs.d7c20391.svg";